import { render, staticRenderFns } from "./FooterHomeEight.vue?vue&type=template&id=0984ed28&"
import script from "./FooterHomeEight.vue?vue&type=script&lang=js&"
export * from "./FooterHomeEight.vue?vue&type=script&lang=js&"
import style0 from "./FooterHomeEight.vue?vue&type=style&index=0&id=0984ed28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports